(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-breakdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luma-results-breakdown')) {
    customElements.define('luma-results-breakdown', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.animate !== 'true' || this.hasAttribute('data-revealed') || this.observer) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        const cards = this.querySelector('.luma-results__cards');
        if (!cards) return;
        this.setAttribute('data-pending', '');
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.removeAttribute('data-pending');
          this.setAttribute('data-revealed', '');
          this.observer.disconnect();
        }, { threshold: 0.1 });
        this.observer.observe(cards);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.removeAttribute('data-pending');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-comparaison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luma-mature-comparison')) {
    customElements.define('luma-mature-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.viewport = this.querySelector('.luma-compare__viewport');
        this.table = this.querySelector('table');
        this.controls = this.querySelector('.luma-compare__controls');
        this.previous = this.querySelector('.luma-compare__previous');
        this.next = this.querySelector('.luma-compare__next');
        if (!this.viewport || !this.table) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.table);
        this.setAttribute('data-ready', '');
        this.update();
      }
      move(direction) {
        const distance = this.table.querySelector('.luma-compare__brand').getBoundingClientRect().width;
        this.viewport.scrollBy({ left: distance * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const position = Math.max(0, Math.min(max, this.viewport.scrollLeft));
        this.controls.hidden = max <= 1;
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= max - 1;
        this.style.setProperty('--lcmp-progress-left', `${max > 0 ? position / max * 33.3333 : 0}%`);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-four-sign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luma-four-signs')) {
    customElements.define('luma-four-signs', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.viewport = this.querySelector('.luma-signs__viewport');
        if (!this.viewport) return;
        this.navigation = this.querySelector('.luma-signs__navigation');
        this.fill = this.querySelector('.luma-signs__progress span');
        this.previous = this.querySelector('[data-luma-sign-prev]');
        this.next = this.querySelector('[data-luma-sign-next]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const total = this.viewport.scrollWidth;
          const visible = this.viewport.clientWidth;
          const remaining = Math.max(0, total - visible);
          const position = Math.max(0, Math.min(remaining, this.viewport.scrollLeft));
          this.navigation.hidden = remaining <= 2;
          this.fill.style.transform = `scaleX(${total ? Math.min(1, (visible + position) / total) : 1})`;
          if (this.previous) this.previous.disabled = position <= 2;
          if (this.next) this.next.disabled = position >= remaining - 2;
        };
        this.move = (direction) => {
          const first = this.querySelector('[data-luma-sign-card]');
          if (!first) return;
          const step = first.getBoundingClientRect().width + 12;
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.viewport.scrollBy({ left: direction * step, behavior });
        };
        this.viewport.addEventListener('scroll', this.update, { ...options, passive: true });
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = event.target.closest('[data-luma-sign-card]');
          if (!selected) return;
          const left = this.viewport.scrollLeft + selected.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({ left, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
        this.classList.add('is-enhanced');
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-lash-care"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luma-lash-care')) {
    customElements.define('luma-lash-care', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.addEventListener('shopify:block:select', (event) => {
          const ingredient = event.target.closest('.luma-care__ingredient');
          if (ingredient && this.contains(ingredient)) ingredient.open = true;
        }, { signal: this.events.signal });
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-more-lash"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luma-more-lashes')) {
    customElements.define('luma-more-lashes', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        this.viewport = this.querySelector('.luma-more__viewport');
        if (!this.viewport) return;
        this.navigation = this.querySelector('.luma-more__navigation');
        this.fill = this.querySelector('.luma-more__progress span');
        this.previous = this.querySelector('[data-luma-prev]');
        this.next = this.querySelector('[data-luma-next]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const total = this.viewport.scrollWidth;
          const visible = this.viewport.clientWidth;
          const remaining = Math.max(0, total - visible);
          const position = Math.max(0, Math.min(remaining, this.viewport.scrollLeft));
          this.navigation.hidden = remaining <= 2;
          this.fill.style.transform = `scaleX(${total ? Math.min(1, (visible + position) / total) : 1})`;
          if (this.previous) this.previous.disabled = position <= 2;
          if (this.next) this.next.disabled = position >= remaining - 2;
        };
        this.move = (direction) => {
          const first = this.querySelector('[data-luma-card]');
          if (!first) return;
          const step = first.getBoundingClientRect().width + 12;
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.viewport.scrollBy({ left: direction * step, behavior });
        };
        this.viewport.addEventListener('scroll', this.update, { ...options, passive: true });
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const selected = event.target.closest('[data-luma-card]');
          if (!selected) return;
          const left = this.viewport.scrollLeft + selected.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.viewport.scrollTo({ left, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.viewport);
        this.classList.add('is-enhanced');
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-phot"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luma-photo-marquee')) {
    customElements.define('luma-photo-marquee', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.luma-photos__viewport');
        this.track = this.querySelector('.luma-photos__track');
        this.group = this.querySelector('[data-original]');
        this.control = this.querySelector('.luma-photos__control');
        if (!this.group || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.selectedBlock = null;
        this.userPaused = false;
        this.offscreen = false;
        this.control.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updateState();
        }, options);
        this.motion.addEventListener('change', () => this.updateState(), options);
        document.addEventListener('visibilitychange', () => this.updateState(), options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          this.selectedBlock = [...this.group.children].find(item => item.dataset.photoId === event.detail.blockId);
          this.updateState();
          if (this.selectedBlock) {
            this.viewport.scrollLeft = this.selectedBlock.offsetLeft - (this.viewport.clientWidth - this.selectedBlock.clientWidth) / 2;
          }
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.contains(event.target)) return;
          this.selectedBlock = null;
          this.updateState();
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.offscreen = !entries[0].isIntersecting;
          this.updateState();
        });
        this.intersectionObserver.observe(this);
        this.measure();
      }
      measure() {
        const distance = this.group.getBoundingClientRect().width;
        if (!distance || !this.viewport.clientWidth) return;
        const copies = Math.ceil(this.viewport.clientWidth / distance) + 1;
        const existing = [...this.track.querySelectorAll('[data-clone]')];
        if (existing.length !== copies) {
          existing.forEach(copy => copy.remove());
          for (let index = 0; index < copies; index += 1) {
            const copy = this.group.cloneNode(true);
            copy.removeAttribute('data-original');
            copy.setAttribute('data-clone', '');
            copy.setAttribute('aria-hidden', 'true');
            copy.setAttribute('inert', '');
            [copy, ...copy.querySelectorAll('*')].forEach(element => {
              [...element.attributes].forEach(attribute => {
                if (attribute.name === 'id' || attribute.name === 'data-photo-id' || attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
              });
              if (element.tagName === 'IMG') {
                element.alt = '';
                element.loading = 'eager';
              }
            });
            this.track.append(copy);
          }
        }
        this.style.setProperty('--lp-distance', `${distance}px`);
        this.setAttribute('data-ready', '');
        this.updateState();
      }
      updateState() {
        const manual = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(this.selectedBlock);
        const wasManual = this.hasAttribute('data-manual');
        this.toggleAttribute('data-manual', manual);
        this.toggleAttribute('data-user-paused', this.userPaused);
        this.toggleAttribute('data-stopped', this.userPaused || this.offscreen || document.hidden);
        this.viewport.tabIndex = manual ? 0 : -1;
        this.control.hidden = manual;
        this.control.setAttribute('aria-label', this.userPaused ? this.control.dataset.playLabel : this.control.dataset.pauseLabel);
        if (wasManual && !manual) this.viewport.scrollLeft = 0;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luma-lash-timeline')) {
    customElements.define('luma-lash-timeline', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.tabs = [...this.querySelectorAll('[data-step]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.tablist = this.querySelector('.luma-timeline__tabs');
        if (!this.tabs.length || !this.tablist) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          tab.parentElement.setAttribute('role', 'presentation');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].tabIndex = 0;
        });
        this.tablist.addEventListener('click', event => {
          const tab = event.target.closest('[data-step]');
          if (!tab || !this.tablist.contains(tab)) return;
          event.preventDefault();
          this.activate(Number(tab.dataset.step));
        }, options);
        this.tablist.addEventListener('keydown', event => {
          const tab = event.target.closest('[data-step]');
          if (!tab) return;
          const index = Number(tab.dataset.step);
          const moves = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: 2, ArrowUp: -2 };
          let next;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === ' ') next = index;
          else if (event.key in moves) next = (index + moves[event.key] + this.tabs.length) % this.tabs.length;
          else return;
          event.preventDefault();
          this.activate(next, true);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const index = this.tabs.findIndex(tab => tab.parentElement.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.activate(index);
        }, options);
        this.activate(this.activeIndex ?? 0);
        this.setAttribute('data-ready', '');
      }
      activate(index, focus = false) {
        this.activeIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
        this.tabs.forEach((tab, current) => {
          const selected = current === this.activeIndex;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[current].hidden = !selected;
        });
        if (focus) this.tabs[this.activeIndex].focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
